import { z } from "zod";

import { patientsApiContract } from "@libs/api/patients";
import { i18n } from "@/i18n";

export const usernameSchema =
  patientsApiContract.auth.addUsernameAccount.body.shape.username;

export const authIdentifierFormSchema = z.object({
  identifier: z.union([z.email(), usernameSchema], {
    message: i18n.t("native:authScreen.invalidIdentifier"),
  }),
});

export type AuthIdentifierFormType = z.infer<typeof authIdentifierFormSchema>;

const newPasswordSchema = z.string().min(10, {
  message: i18n.t("native:createPasswordScreen.passwordRequirement"),
});

export const requiredEmailFormSchema = z.object({
  email: z.email({ message: i18n.t("common:errors.invalidEmail") }),
});

export type RequiredEmailFormType = z.infer<typeof requiredEmailFormSchema>;

export const passwordFormSchema = z.object({
  password: z
    .string()
    .min(1, { message: i18n.t("common:validation.requiredPassword") }),
});

export type PasswordFormType = z.infer<typeof passwordFormSchema>;

export const createPasswordFormSchema = z.object({
  password: newPasswordSchema,
});

export type CreatePasswordFormType = z.infer<typeof createPasswordFormSchema>;

export const resetPasswordFormSchema = z
  .object({
    password: newPasswordSchema,
    confirmPassword: z
      .string()
      .min(1, { message: i18n.t("common:validation.requiredPassword") }),
  })
  .refine(data => data.password === data.confirmPassword, {
    path: ["confirmPassword"],
    message: i18n.t("common:validation.passwordMismatch"),
  });

export type ResetPasswordFormType = z.infer<typeof resetPasswordFormSchema>;

export const mfaPhoneFormSchema = z.object({
  phoneNumber: z.string().min(10, {
    message: i18n.t("common:validation.invalidPhone"),
  }),
});

export type MfaPhoneFormType = z.infer<typeof mfaPhoneFormSchema>;

export const MFA_OTP_LENGTH = 6;

export const mfaVerifyFormSchema = z.object({
  code: z.string().length(MFA_OTP_LENGTH, {
    message: i18n.t("common:validation.invalidCode"),
  }),
});

export type MfaVerifyFormType = z.infer<typeof mfaVerifyFormSchema>;

export type AuthUserType = {
  id: string;
  idToken: string;
  email: string;
  loginMethod: string;
};
